import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { SanitizeHTMLString } from "@/react/components/shared/uikit/SanitizeContent";
import { useUpgradePlanModal } from "@circle-react-shared/UpgradePlan";
import { UPGRADE_FLOW_SOURCES } from "@circle-react-shared/UpgradePlan/constants";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { BlueWrapper } from "./BlueWrapper";

interface EnterprisePriceIncreaseProps {
  planId?: number;
}

export const EnterprisePriceIncrease = ({
  planId,
}: EnterprisePriceIncreaseProps) => {
  const upgradePlanModal = useUpgradePlanModal();

  const handleUpgradeClick = async () => {
    await upgradePlanModal.show({
      planId,
      planTier: planId ? undefined : "enterprise",
      source: UPGRADE_FLOW_SOURCES.ENTERPRISE_PRICE_INCREASE_BANNER,
      showPlanDetails: true,
    });
  };

  return (
    <BlueWrapper>
      <div className="flex flex-row gap-x-4">
        <div>
          <Icon type="32-ai-bot" size={32} className="!h-7 !w-7" />
        </div>
        <div className="grid gap-4">
          <Typography.LabelLg weight="semibold" color="text-secondary">
            {t("pricing_plans.enterprise_price_increase_banner.title")}
          </Typography.LabelLg>
          <Typography.LabelSm color="text-secondary">
            <SanitizeHTMLString
              content={t(
                "pricing_plans.enterprise_price_increase_banner.subtitle",
              )}
            />
          </Typography.LabelSm>
          <Typography.BodySm color="text-secondary">
            {t("pricing_plans.enterprise_price_increase_banner.description")}
          </Typography.BodySm>
          <div>
            <Button
              variant="secondary"
              onClick={handleUpgradeClick}
              className="!bg-white/0"
            >
              {t("pricing_plans.enterprise_price_increase_banner.button")}
            </Button>
          </div>
        </div>
      </div>
    </BlueWrapper>
  );
};
